import { useState } from "react";
import { Link } from "react-router-dom";
import { WHATSAPP_LINK } from "@/config";
import { Heart, Menu, X } from "lucide-react";
import { Button } from "@/components/ui/button";

const links = [
  { label: "Why Us", href: "#why-us" },
  { label: "How It Works", href: "#how-it-works" },
  { label: "Pricing", href: "#pricing" },
  { label: "FAQ", href: "#faq" },
];

const Navbar = () => {
  const [open, setOpen] = useState(false);
  return (
    <header
      data-testid="site-navbar"
      className="sticky top-0 z-40 bg-[#FDFBF7]/90 backdrop-blur-md border-b border-border"
    >
      <nav className="max-w-6xl mx-auto px-4 h-16 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-2">
          <span className="flex items-center justify-center w-9 h-9 rounded-full bg-primary text-primary-foreground">
            <Heart className="w-5 h-5" />
          </span>
          <span className="font-serif text-xl font-semibold tracking-tight">MyySpace</span>
        </Link>

        <div className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}
              className="text-sm text-muted-foreground hover:text-foreground transition-colors duration-300"
            >
              {l.label}
            </a>
          ))}
          <a href="#booking">
            <Button data-testid="nav-request-button" className="rounded-full px-6">
              Request a session
            </Button>
          </a>
        </div>

        <button
          className="md:hidden p-2"
          onClick={() => setOpen((v) => !v)}
          data-testid="nav-mobile-toggle"
          aria-label="Toggle menu"
        >
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </nav>

      {open && (
        <div className="md:hidden bg-[#FDFBF7] border-t border-border px-4 py-4 flex flex-col gap-4">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setOpen(false)}
              className="text-sm text-muted-foreground"
              data-testid={`nav-mobile-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}
            >
              {l.label}
            </a>
          ))}
          <a href="#booking" onClick={() => setOpen(false)}>
            <Button className="rounded-full w-full">Request a session</Button>
          </a>
          <a href={WHATSAPP_LINK} target="_blank" rel="noopener noreferrer" className="text-sm text-[#25D366] font-medium">
            Chat on WhatsApp
          </a>
        </div>
      )}
    </header>
  );
};

export default Navbar;
